import { render, staticRenderFns } from "./dish-translation-form.vue?vue&type=template&id=929c5cfe"
import script from "./dish-translation-form.vue?vue&type=script&lang=js"
export * from "./dish-translation-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports